import { AntdLayout, Avatar, Space, Typography } from "@pankod/refine-antd";
import { useGetIdentity } from "@pankod/refine-core";
import { IUserLogIn } from "types/user.interface";

// const { DownOutlined } = Icons;
const { Text } = Typography;

export const Header: React.FC = () => {
  // const { i18n } = useTranslation();
  // const locale = useGetLocale();
  // const changeLanguage = useSetLocale();
  const { data: user } = useGetIdentity<IUserLogIn>();

  // const currentLocale = locale();

  // const menu = (
  //   <Menu selectedKeys={[currentLocale]}>
  //     {[...(i18n.languages || [])].sort().map((lang: string) => (
  //       <Menu.Item
  //         key={lang}
  //         onClick={() => changeLanguage(lang)}
  //         icon={
  //           <span style={{ marginRight: 8 }}>
  //             <Avatar size={16} src={`/images/flags/${lang}.svg`} />
  //           </span>
  //         }
  //       >
  //         {lang === "en" ? "English" : "German"}
  //       </Menu.Item>
  //     ))}
  //   </Menu>
  // );

  return (
    <AntdLayout.Header
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "0px 24px",
        height: "64px",
        backgroundColor: "#FFF",
      }}
    >
      {/* <Dropdown overlay={menu}>
        <Button type="link">
          <Space>
            <Avatar size={16} src={`/images/flags/${currentLocale}.svg`} />
            {currentLocale === "en" ? "English" : "German"}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown> */}
      <Space style={{ marginLeft: "8px" }}>
        {user?.username && (
          <Text ellipsis strong>
            {user.username}
          </Text>
        )}
        {user?.avatar && <Avatar src={user?.avatar} alt={user?.username} />}
      </Space>
    </AntdLayout.Header>
  );
};
